export const TIMELINE = {
  intro: { start: 0, end: 0.06 },
  brain: { start: 0.06, end: 0.15 },
  connectionSetup: {
    slideIn: [0.13, 0.17],
    visible: [0.15, 0.3],
    content: [0.175, 0.275],
  },
  security: {
    slideIn: [0.31, 0.35],
    visible: [0.33, 0.47],
    content: [0.34, 0.41],
  },
  chat: {
    slideIn: [0.45, 0.49],
    visible: [0.49, 0.56],
    content: [0.52, 0.55],
  },
  forget: {
    slideIn: [0.56, 0.6],
    visible: [0.6, 0.86],
    subCount: 4,
  },
  doAnything: {
    slideIn: [0.88, 0.92],
    visible: [0.92, 1.0],
  },
}

export function lerp(start: number, end: number, t: number): number {
  return start + (end - start) * t
}
